<template>
  <div class="activation-toggle">
    <toggle-button :sync="true"
      v-model="isActivated"
      :color="{checked: '#229863', unchecked: '#CB3247'}"
      @change="toggleActivation"/>
    <div class="spinner-border small-spinner" role="status" v-if="isLoading">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivationToggle',
  props: {
    activationStatus: {
      type: Boolean,
      required: true
    },
    isLoading: Boolean
  },
  data() {
    return {
      isActivated: false
    }
  },
  created() {
    this.isActivated = this.activationStatus;
  },
  methods: {
    toggleActivation() {
      this.$emit('toggleActivation');
    }
  },
  watch: {
    isLoading(isLoading) {
      if (!isLoading) {
        // update activation once finished loading in case update failed
        this.isActivated = this.activationStatus;
      }
    }
  }
}
</script>
